import React from "react";
import { Modal, ModalBody, Spinner } from "reactstrap";
import { Button, Icon } from "../../components/Component";

export const DeleteModal = ({deleteModal,toggleDeleteModal,name,loading,deleteRow,rowData}) => {
  return (
    <Modal isOpen={deleteModal} toggle={toggleDeleteModal}>
      <ModalBody className="modal-body-lg text-center">
        <div className="nk-modal">
          <Icon className={`nk-modal-icon icon-circle icon-circle-xxl ni ni-trash bg-danger`}></Icon>
          <h4 className="nk-modal-title">{name}</h4>
          <div className="nk-modal-text">
            <p className="lead">Are you sure? You won't be able to revert this!</p>
          </div>
          <div className="nk-modal-action mt-5">
            <Button size="lg" className={`btn-mw me-2`} color={`primary`} onClick={toggleDeleteModal}>
              Cancel
            </Button>
            <Button
              disabled={loading}
              size="lg"
              className={`btn-mw`}
              color={`danger`}
              onClick={(e) => {
                deleteRow(rowData);
              }}
            >
              {loading ? <Spinner size="sm" color="light" /> : "Delete"}
            </Button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};
